export const SNACKBAR_DURATION = 7000; // in milliseconds
export const SNACKBAR_DURATION_SHORT = 3000; // in milliseconds
